export {
    Tabs,
    ITabsProps,
    TTabsValue,
    ITabsContext,
    TabsContext,
} from './src/tabs';
export {
    TabsItem,
    ITabsItemProps,
} from './src/tabs-item';
export {
    ITabsNavItemProps,
} from './src/tabs-nav';
